export class ForgotPasswordModel {
  public email: string;
  public languageId: number;
}
